import { IntegrationType } from "@types";
import * as yup from "yup";
import { boolean, object, string } from "yup";

export const IntegrationSchema = object({
  id: string().required(),
  userId: string().optional(), // Optional because backend excludes it for security
  type: string().oneOf(Object.values(IntegrationType)).required(),
  enabled: boolean().required(),
  expiresAt: string().nullable().default(null),
  scope: string().defined().default(''),
  metadata: object().required(),
  createdAt: string().required(),
  updatedAt: string().required(),
});

export const IntegrationResponseSchema = object({
  integration: IntegrationSchema.nullable().optional(),
});

export const SlackIntegrationMetadataSchema = object({
  slackWorkspaceId: string().required(),
  slackWorkspaceName: string().nullable().default(null),
  canManageInstallation: boolean().required(),
  currentUserBinding: object({
    connected: boolean().required(),
    slackUserId: string().optional(),
  }).required(),
});

export const SlackIntegrationSchema = IntegrationSchema.shape({
  type: string().oneOf([IntegrationType.SLACK]).required(),
  metadata: SlackIntegrationMetadataSchema.required(),
});

export const SlackIntegrationResponseSchema = object({
  integration: SlackIntegrationSchema.nullable().optional(),
});

export const SlackAuthUrlResponseSchema = object({
  authUrl: string().required(),
});

export const SlackTestResponseSchema = object({
  success: boolean().required(),
  message: string().optional(),
  error: string().optional(),
});

export const IntegrationEnabledResponseSchema = object({
  success: boolean().required(),
  integration: object({
    id: string().required(),
    enabled: boolean().required(),
  })
    .nullable()
    .optional(),
});

export type IntegrationResponseType = yup.InferType<
  typeof IntegrationResponseSchema
>;

export type Integration = yup.InferType<typeof IntegrationSchema>;

export type SlackIntegration = yup.InferType<typeof SlackIntegrationSchema>;

export type SlackAuthUrlResponse = yup.InferType<
  typeof SlackAuthUrlResponseSchema
>;

export type SlackTestResponse = yup.InferType<typeof SlackTestResponseSchema>;

export type IntegrationEnabledResponse = yup.InferType<
  typeof IntegrationEnabledResponseSchema
>;
